/**
 * @file KnowledgeBaseMention 类型定义与常量
 */
import type {
  IKnowledgeDocItem,
  IKnowledgeBaseItem,
} from './hooks/useKnowledgeBaseApi';
import type { ISelectedKnowledgeTagData } from './components/SelectedKnowledgeTag';
import type { TKnowledgeMentionOpenReason } from './hooks/useKnowledgeMentionHost';

/** CSS 前缀 */
export const PREFIX = 'dba-kb-mention';

/** NewRegionSelect 右侧列表宽度（与 Chart # 面板一致） */
export const KB_POPOVER_RIGHT_LIST_WIDTH = 335;

/**
 * 双栏列表区高度（与 Chart # 浮层总高对齐）：
 * Chart = 头部 72 + 搜索区 ~54 + content 285；
 * KB 无头部，搜索区收紧后 ~38 → 285 + 72 + (54 - 38) = 373
 */
export const KB_POPOVER_CONTENT_HEIGHT = 373;

/** 右侧虚拟列表高度（content 373 − 标题行 ~22） */
export const KB_POPOVER_RIGHT_LIST_HEIGHT = 351;

/** 与 Skill / Chart 一致：离开后延迟关闭 */
export const KB_HOVER_AUTO_CLOSE_DELAY_MS = 200;

/**
 * @ 模式下扁平列表项类型
 * - kb: 知识库分组头，选中时批量添加该分组下所有文档
 * - doc: 单个文档项
 */
export type TAtFlatItem =
  | { type: 'kb'; kb: IKnowledgeBaseItem; docs: IKnowledgeDocItem[]; }
  | { type: 'doc'; kb: IKnowledgeBaseItem; doc: IKnowledgeDocItem; };

/** KnowledgeBaseMention 组件属性 */
export interface IKnowledgeBaseMentionProps {
  selectedItems?: ISelectedKnowledgeTagData[];
  onSelectedChange?: (items: ISelectedKnowledgeTagData[]) => void;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  /** 按钮 / hover 显式打开（与 Skill 对齐，切 button 模式并清 @ 索引） */
  onOpenAsButton?: () => void;
  mentionQuery?: string;
  openReason?: TKnowledgeMentionOpenReason;
  mentionAnchorRef?: React.RefObject<HTMLElement | null>;
  inputBoxContainerRef?: React.RefObject<HTMLElement | null>;
  isDropDown?: boolean;
  from?: string;
  onAtModeSelect?: (
    insertLabel?: string,
    addedItems?: ISelectedKnowledgeTagData[],
  ) => void;
  /**
   * 按钮模式关面板：用整份新选区文案替换整份旧选区文案。
   * newLabel 为空表示删掉旧串；旧串不在正文时由父组件插入 newLabel。
   */
  onLabelReplace?: (
    oldLabel: string,
    newLabel: string,
    nextItems?: ISelectedKnowledgeTagData[],
  ) => void;
  enableHoverOpen?: boolean;
  /** 打开面板前保存编辑器选区（mousedown 时调用） */
  onBeforePanelOpen?: () => void;
  /** 按钮模式：在保存的光标处插入新增知识库（不合并进已有 tag） */
  onInsertAtCursor?: (
    insertLabel: string,
    addedItems?: ISelectedKnowledgeTagData[],
  ) => void;
  /** 按钮模式关面板：按勾选结果同步输入框 mention */
  onPanelSync?: (nextItems: ISelectedKnowledgeTagData[]) => void;
  /** 面板确认/关闭后清理编辑器冻结插入偏移 */
  onPanelCommit?: () => void;
}
